import React, { useState } from 'react'
import { useFormik, validateYupSchema } from 'formik'
import * as Yup from 'yup'
import toast from 'react-hot-toast'
import { useCreateBankAccountMutation, useListBanksQuery } from '../../../features/account/bankSlice'
import { FiChevronDown } from 'react-icons/fi'
import { BankType } from '../../../utils/bankType'

export const BankAccount = ({
  setCurrentStep,
}: {
  setCurrentStep: React.Dispatch<React.SetStateAction<'init' | 'Success'>>
}) => {
  const [createBankAccount, { isLoading, isSuccess }] =
    useCreateBankAccountMutation()

  const {
    data: banks,
    isLoading: isLoadingBanks,
    isSuccess: isSuccessBanks,
  } = useListBanksQuery();

  console.log({ banks })

  const formik = useFormik({
    initialValues: {
      bankName: '',
      accountName: '',
      accountNumber: '',
      accountType: 'bank',
      bankCode: '',
    },
    validationSchema: Yup.object().shape({
      bankName: Yup.string().required('Bank name is required'),
      accountNumber: Yup.string().required('Account number / details is required'),
      bankCode: Yup.string().required('Select a Bank'),
    }),
    onSubmit: async (values) => {
      try {
        toast.loading('Creating bank account...')

        const bank = banks?.find((bank: any) => bank.bank_code === values.bankCode);

        if (!bank) {
          toast.dismiss()
          toast.error('Select the Bank first')
          return;
        }
        await createBankAccount({
          ...values,
          accountNumber: values.accountNumber.toString(),
          type: bank?.type || BankType.MANUAL,
        }).unwrap()
        formik.resetForm()
        toast.dismiss()
        setCurrentStep('Success')
      } catch (error: any) {
        toast.dismiss()
        toast.error(error?.data?.message)
        console.log(error)
      }
    },
  })

  return (
    <form action='' className='mt-8 w-full' onSubmit={formik.handleSubmit}>
      <div className='flex flex-col gap-2'>
        <label htmlFor='bankCode' className='text-xs text-white/70'>
          Select Bank / Payment Method
        </label>
        <div className='relative flex items-center justify-between transition-all duration-200 w-full overflow-hidden bg-gray-600 border border-primary/40 rounded-lg text-sm text-white/70 placeholder-white/40 focus:outline-none focus:border-primary'>
          <select
            name='bankCode'
            id='bankCode'
            value={formik.values.bankCode}
            onChange={(e) => {
              if (e.target.selectedOptions[0].value === "6") {
                formik.setFieldValue('bankName', '');
              } else {
                formik.setFieldValue('bankName', e.target.selectedOptions[0].text);
              }
              formik.handleChange(e);
            }}
            className='bg-gray-600 px-4 py-3 appearance-none focus:outline-none w-full'
          >
            <option value='' disabled>
              Select a bank
            </option>
            {
              banks?.map((bank: any) => (
                <option value={bank.bank_code}>{bank.bank_name}</option>
              ))
            }
          </select>
          <FiChevronDown className='absolute top-4 right-3 text-white/60 text-base z-10' />
        </div>
        <p className='text-red-500 text-xs'>
          {formik.touched.bankCode &&
            Boolean(formik.errors.bankCode) &&
            formik.errors.bankCode}
        </p>
      </div>

      {
        formik.values.bankCode === "6" && (
          <div className='flex flex-col gap-2'>
            <label htmlFor='bankName' className='text-xs text-white/70'>
              Bank Name
            </label>
            <input
              id='bankName'
              name='bankName'
              type='text'
              value={formik.values.bankName}
              onChange={formik.handleChange}
              placeholder='Kuda Microfinance'
              className='form-input'
            />

            <p className='text-red-500 text-xs'>
              {formik.touched.bankName &&
                Boolean(formik.errors.bankName) &&
                formik.errors.bankName}
            </p>
          </div>
        )
      }

      {
        Number(formik.values.bankCode) >= 6 ? (
          <>
            <div className='flex flex-col gap-2 mt-3'>
              <label htmlFor='accountName' className='text-xs text-white/70'>
                Account Name
              </label>
              <input
                id='accountName'
                name='accountName'
                type='text'
                value={formik.values.accountName}
                onChange={formik.handleChange}
                placeholder='John Doe'
                className='form-input'
              />
              <p className='text-red-500 text-xs'>
                {formik.touched.accountName &&
                  Boolean(formik.errors.accountName) &&
                  formik.errors.accountName}
              </p>
            </div>
            <div className='flex flex-col gap-2 mt-3'>
              <label htmlFor='accountNumber' className='text-xs text-white/70'>
                Account Number
              </label>
              <input
                id='accountNumber'
                name='accountNumber'
                type='text'
                value={formik.values.accountNumber}
                onChange={formik.handleChange}
                placeholder=''
                className='form-input'
              />
              <p className='text-red-500 text-xs'>
                {formik.touched.accountNumber &&
                  Boolean(formik.errors.accountNumber) &&
                  formik.errors.accountNumber}
              </p>
            </div>
          </>
        ) : (
          <div className='flex flex-col gap-2 mt-3'>
            <label htmlFor='accountNumber' className='text-xs text-white/70'>
              Account Details
            </label>
            <input
              id='accountNumber'
              name='accountNumber'
              type='text'
              min={0}
              onWheel={(event) => event.currentTarget.blur()}
              value={formik.values.accountNumber}
              onChange={formik.handleChange}
              placeholder=''
              className='form-input'
            />
            <p className='text-red-500 text-xs'>
              {formik.touched.accountNumber &&
                Boolean(formik.errors.accountNumber) &&
                formik.errors.accountNumber}
            </p>
          </div>
        )
      }


      <button
        type='submit'
        className='btn-primary py-3 rounded-md w-full mt-12'
      // onClick={() => setCurrentStep('Success')}
      >
        Add Account
      </button>
    </form>
  )
}
